import { useState, useEffect, useRef } from "react";
export default function ProductsGrid() {
  const [activeIndex, setActiveIndex] = useState(0);
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible(true);
    }, {
      threshold: 0.15
    });
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);
  const products = [{
    id: 0,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696675/img/dark_black_protective_film.png",
    alt: "Protective film applied to a vehicle surface",
    label: "Matrix ppf",
    title: "Dark Black / Light Black"
  }, {
    id: 1,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696675/img/windshield_glass_protective_film.png",
    alt: "Windshield and glass protective film",
    label: "Matrix ppf",
    title: "Winshield Film"
  }, {
    id: 2,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696675/img/sunroof_protective_film.png",
    alt: "Sunroof protective film",
    label: "Matrix ppf",
    title: "Sunroof Film"
  }];
  const featured = products[activeIndex];
  const others = products.filter((_, i) => i !== activeIndex);
  return <section ref={sectionRef} className="relative bg-background text-foreground overflow-hidden py-20 px-6 md:px-16">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Inter:wght@300;400;500&display=swap');`}</style>

      <div className={`transition-opacity duration-700 ${visible ? "opacity-100" : "opacity-0"}`}>
        <div className="flex items-end justify-between mb-12 border-b border-border pb-6">
          <h2 style={{
          fontFamily: "'Bebas Neue', cursive",
          letterSpacing: "0.18em"
        }} className="text-7xl md:text-9xl text-foreground leading-none select-none">
            PRODUCTS
          </h2>
          <span style={{
          fontFamily: "'Inter', sans-serif"
        }} className="text-xs text-muted-foreground tracking-widest uppercase mb-2">
            {activeIndex + 1} / {products.length}
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-8 group relative overflow-hidden rounded-2xl bg-muted">
            <div className="relative overflow-hidden aspect-[16/9]">
              <img src={featured.image} alt={featured.alt} className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-6 flex items-end justify-between">
              <div>
                <span style={{
                fontFamily: "'Inter', sans-serif"
              }} className="block text-white/60 text-xs tracking-[0.3em] uppercase mb-1">
                  {featured.label}
                </span>
                <h3 style={{
                fontFamily: "'Bebas Neue', cursive",
                letterSpacing: "0.1em"
              }} className="text-white text-4xl md:text-5xl leading-none">
                  {featured.title}
                </h3>
              </div>
              <button className="w-14 h-14 rounded-lg bg-white flex items-center justify-center shadow-lg hover:bg-foreground hover:scale-110 transition-all duration-300 flex-shrink-0 group/btn" onClick={() => setActiveIndex((activeIndex + 1) % products.length)} aria-label="Next product">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696675/img/arrow-6.png" alt="" className="w-5 h-5 group-hover/btn:invert transition-all duration-300" />
              </button>
            </div>
          </div>

          <div className="lg:col-span-4 flex flex-col gap-4">
            {others.map((product, idx) => <button key={product.id} onClick={() => setActiveIndex(product.id)} className="group relative overflow-hidden rounded-xl bg-muted flex-1 text-left hover:ring-2 hover:ring-foreground transition-all duration-300 focus:outline-none">
                <div className="relative overflow-hidden aspect-video">
                  <img src={product.image} alt={product.alt} className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-transparent" />
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <span style={{
                fontFamily: "'Inter', sans-serif"
              }} className="block text-white/50 text-xs tracking-[0.25em] uppercase mb-0.5">
                    {product.label}
                  </span>
                  <h4 style={{
                fontFamily: "'Bebas Neue', cursive",
                letterSpacing: "0.08em"
              }} className="text-white text-2xl leading-none">
                    {product.title}
                  </h4>
                </div>
              </button>)}
          </div>
        </div>

        <div className="flex items-center gap-3 mt-8 justify-center">
          {products.map((_, i) => <button key={i} onClick={() => setActiveIndex(i)} aria-label={`Go to product ${i + 1}`} className={`transition-all duration-300 rounded-full focus:outline-none ${i === activeIndex ? "w-8 h-2 bg-foreground" : "w-2 h-2 bg-muted-foreground/40 hover:bg-muted-foreground"}`} />)}
        </div>
      </div>
    </section>;
}